export default {"src":"/_next/static/media/waterMeter.97f502d2.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};